<template>
    <el-select
        filterable
        clearable
        v-model="selected"
        :multiple="multiple"
        :multiple-limit="multipleLimit"
    >
        <el-option v-for="i in list" :key="i.icon" :label="i.icon" :value="i.icon">
            <i class="material-icons" style="padding-right:10px;">{{i.icon}}</i>{{i.icon}}
        </el-option>
    </el-select>
</template>
<script>
    import ElSelect from 'element-ui/lib/select';
    import ElOption from 'element-ui/lib/option';

    export default {
        data: function () {
            return{
                selected: this.value,
                list: []
            }
        },
        components: {
            ElSelect,
            ElOption
        },
        props: ['value','icons'],
        watch: {
            value: function (value) {
                this.selected = value;
            },
            selected: function (value) {
                this.$emit('input', value);
            }
        },
        mounted: function () {
            this.list = this.icons;
        }
    }
</script>